// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__1wwSk","approved":"Status_approved__1bkH7","rejected":"Status_rejected__1Br42","expired":"Status_expired__WTi1r","label":"Status_label__2GXmA"};